export default __webpack_public_path__ + "static/char-s-01-cht-d527c3c436a70636bc04f3a3e0b76e2e.webp";